import { AppRoutes } from "../../../common/routes/app_routes";

export interface ChangeRequestViewer {
  isSeller?: boolean;
  isBuyer?: boolean;
}

export function getChangeRequestsListPath(viewer: ChangeRequestViewer): string {
  // Buyers view their change requests inside the account tab.
  if (viewer.isBuyer) return `${AppRoutes.ACCOUNT}?tab=change-requests`;
  // Sellers have a dedicated list page (MyChangeRequestsPage). The seller
  // settings page does not render a change-requests section, so routing there
  // landed on a blank settings view.
  if (viewer.isSeller) return AppRoutes.CHANGE_REQUESTS;
  return AppRoutes.ADMIN_CHANGE_REQUESTS;
}
